var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'app-style-for-homepage': this.$route.path == '/'},attrs:{"id":"app"}},[_c('GoTop'),_c('Nav',{attrs:{"bg":"bg1"}}),_c('keep-alive',[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c(Component,{tag:"component"})]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }